<!-- 【画面名】設問開始待ち画面 -->

<template>
    <CommonHeader />
    <div id="entry-question-wait" class="entry-question-wait">
  
      <div class="content">
        <div class="message-area">
          <p class="reception-message" v-if="receptionMessage" v-html='receptionMessage'></p>
          <p class="top-text" v-if="topText" v-html='topText'></p>
  
          <div id="errtext" class="errmsg" v-if="errorMessage" v-html='errorMessage'></div>
  
          <div class="fixed-link">
            <a class="fixed-link-text" v-if="fixedLinkText" v-html='fixedLinkText' v-on:click="clickNextLink"></a>
          </div>
  
          <p class="bottom-text">
            <span class="bottom-text-before" v-if="frontBottomText" v-html='frontBottomText'></span>
            <a class="fixed-link-text" v-if="fixedLinkText" v-html='fixedLinkText' v-on:click="clickNextLink"></a>
            <span class="bottom-text-after" v-if="rearBottomText" v-html='rearBottomText'></span>
          </p>
  
          <p class="link-text">
            <span class="link-text-before" v-if="frontLinkText" v-html='frontLinkText'></span>
            <a class="link-text" v-if="linkName" v-html='linkName' v-bind:href="linkUrl" v-on:click="clickPermLink"></a>
            <span class="link-text-after" v-if="rearLinkText" v-html='rearLinkText'></span>
          </p>
  
        </div>
      </div>
      <!-- /.content -->
  
    </div>
    <CommonFooter />
  </template>
  
  <script>
  /* eslint-disable */
  import CommonHeader from './CommonHeader.vue'
  import CommonFooter from './CommonFooter.vue'
  
  export default {
    name: 'EntryQuestionWaitFirst',
    components: {
      CommonHeader,
      CommonFooter,
    },
    data() {
      return {
        receptionMessage: '',
        topText: '',
        bottomText: '',
        fixedLinkText: '',
        frontBottomText: '',
        rearBottomText: '',
        linkName: '',
        linkUrl: '',
        frontLinkText: '',
        rearLinkText: '',
        errorMessage: '',
      }
    },
    inject: ['voteScreanInfo', 'error', 'getJson', 'getReservedWord', 'clearTimer'],
    mounted(){ // ページが読み込まれたらする処理
      // console.log(this.providedData[0].basic_info);
      
      var basicInfo = this.voteScreanInfo[0].basic_info;
      var reservedWord = this.voteScreanInfo[0].reserved_word;
      var questionInfo = this.voteScreanInfo[0].question_info;
      var displayInfo = this.voteScreanInfo[0].display_info;
  
      // 上部下部テキスト設置
      this.topText = this.getReservedWord(displayInfo.start_wait_information_first.qsws_top_text);
      this.fixedLinkText = displayInfo.start_wait_information_first.qsws_fixed_link_text;
      this.frontBottomText = displayInfo.start_wait_information_first.qsws_front_bottom_text;
      this.rearBottomText = displayInfo.start_wait_information_first.qsws_rear_bottom_text;
      this.linkName = displayInfo.start_wait_information_first.qsws_link_name;
      this.linkUrl = displayInfo.start_wait_information_first.qsws_link_url;
      this.frontLinkText = displayInfo.start_wait_information_first.qsws_front_link_text;
      this.rearLinkText = displayInfo.start_wait_information_first.qsws_rear_link_text;
  
  
      // エラーが送られてきたら
      if(this.error[0] == 'timeoutError') {
        this.errorMessage = '送信された質問の受付は終了しています。';
      }
  
    },
    methods: { // 使い回す関数
  
      clickNextLink() {
        this.getJson();
      },
  
      clickPermLink() {
        this.clearTimer();
      }
  
    },
  }
  /* eslint-disable */
  </script>
  